import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { Configuration, DoctorAvailability, GlobalDoctorsApi } from "../api/client-axios";
import { ApiError } from "../model/apiError";
import { PhoneValidation } from "../model/phoneValidationType";
import { Problem } from "../model/problem";
import { apiConfiguration } from "./server";
import { applyRejection } from "./thunkError";

export interface AddDoctorState {
    phoneNumber: string,
    phoneValidation: PhoneValidation,
    doctorAvailability?: DoctorAvailability,
    status: "idle" | "loading" | "error" | "success" | "auth-error";
    error?: string | Problem;
    code?: number;
}


const initialAddDoctorState: AddDoctorState = {
    phoneNumber: "",
    phoneValidation: "",
    status: "idle",
    error: ""
}

export const setDoctorPhoneNumber = createAction('addDoctor/setPhoneNumber', (phoneNumber: string) => { return { payload: phoneNumber }; });
export const setDoctorPhoneValidation = createAction('addDoctor/setPhoneValidation', (phoneValidation: PhoneValidation) => { return { payload: phoneValidation }; });
export const clearAddDoctorError = createAction('addDoctor/clearError');
export const initAddDoctorState = createAction('addDoctor/initState');

export const checkDoctorAvailability = createAsyncThunk<DoctorAvailability, {organizationId: string, phoneNumber: string}, { rejectValue: ApiError }>('addDoctor/checkDoctorAvailability', async (args, thunkApi) => {
    try {
        const api = new GlobalDoctorsApi(apiConfiguration());
        const response = await api.apiV1AdministrationOrganizationOrganizationIdDoctorsAvailableRawPhoneNumberGet(args.organizationId, args.phoneNumber);
        return response.data;
    } catch (error: AxiosError | any) {
        return thunkApi.rejectWithValue({ message: error?.response?.data, statusCode: error?.response?.status });
    }
}); 


const addDoctorSlice = createSlice({
    name: 'addDoctor',
    initialState: initialAddDoctorState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(checkDoctorAvailability.pending, (state, _) => {
                state.status = "loading";
            })
            .addCase(checkDoctorAvailability.fulfilled, (state, action) => {
                state.doctorAvailability = action.payload;
                state.status = "success";
            })
            .addCase(checkDoctorAvailability.rejected, (state, action) => {
                applyRejection(state, action);
            })
            .addCase(setDoctorPhoneNumber, (state, action) => {
                state.status = "idle";
                state.phoneNumber = action.payload;
            })
            .addCase(setDoctorPhoneValidation, (state, action) => {
                state.status = "idle";
                state.phoneValidation = action.payload;
            })
            .addCase(clearAddDoctorError, (state, _) => {
                state.status = "idle";
            })
            .addCase(initAddDoctorState, (state, _) => {
                state.phoneNumber ="";
                state.phoneValidation = "";
                state.status = "idle";
                state.error = "";
            });

           

    }
});

export default addDoctorSlice.reducer;
